import { render, staticRenderFns } from "./PlayerChatUnblockPreview.vue?vue&type=template&id=3a59a9c4&scoped=true&"
import script from "./PlayerChatUnblockPreview.vue?vue&type=script&lang=js&"
export * from "./PlayerChatUnblockPreview.vue?vue&type=script&lang=js&"
import style0 from "./PlayerChatUnblockPreview.vue?vue&type=style&index=0&id=3a59a9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59a9c4",
  null
  
)

export default component.exports